export const AuthApiUrls = {
  login: '/auth/login',
  reLogin: '/auth/login/refresh',
  resetPassword: '/auth/password',
  requestPassword: '/auth/password'
};
